import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { HiCheckCircle } from 'react-icons/hi';
import { useDeviceType } from 'app/hooks';

export const QuestionComponent = (props: any) => {
  const {
    value,
    number,
    answers,
    //  setAnswers,
    handleAnswerChange,
  } = props;
  const { isMobile } = useDeviceType()
  // const quesNo = Number(number);
  //   const handleIconChange = (option: string) => {
  //     setIcon({ ...icon, [quesNo]: option });
  //   };

  return (
    <Box pb="8" borderBottom="1px" borderColor="#1522323B">
      <Box maxW="100%" p="10px" mt="1%">
        <Box maxW="100%" pl="19px">
          <Text fontSize="14px">
            {number}. {value.question_name}
          </Text>
        </Box>
      </Box>

      <Box maxW="100%" pl="15px" ml="1%">
        <Flex flexWrap='wrap' direction={isMobile? 'column' : 'row'} columnGap={isMobile? '2': '10'} rowGap='2'>
          <Flex
            bgColor={'#F6F6F6'}
            color="#828282"
            width={isMobile? '90%' : '40%'}
            p={2}
            alignItems="center"
            gap={'4'}
            onClick={() => {
              // setAnswers({ ...answers, [value.id]: 'option1' });
              handleAnswerChange(value.id, 'option1', number);
            }}
          >
            <Box
              borderRadius="full"
              bg="white"
              borderColor="black"
              minH="20px"
              minW="20px"
              border="1px"
              position="relative"
            >
              <div
                style={{ position: 'absolute', left: '-3.5px', top: '-3px' }}
              >
                {answers[value.id] === 'option1' ? (
                  <HiCheckCircle fontSize="23px" color="#93C025" />
                ) : (
                  ''
                )}
              </div>
            </Box>
            <Box fontSize="14px">{value.options.option1}</Box>
          </Flex>
          <Flex
            bgColor={'#F6F6F6'}
            color="#828282"
            width={isMobile? '90%' : '40%'}
            p={2}
            alignItems="center"
            gap={'4'}
            onClick={() => {
              // setAnswers({ ...answers, [value.id]: 'option2' });
              handleAnswerChange(value.id, 'option2', number);
            }}
          >
            <Box
              borderRadius="full"
              bg="white"
              borderColor="black"
              minH="20px"
              minW="20px"
              border="1px"
              position="relative"
            >
              <div
                style={{ position: 'absolute', left: '-3.5px', top: '-3px' }}
              >
                {answers[value.id] === 'option2' ? (
                  <HiCheckCircle fontSize="23px" color="#93C025" />
                ) : (
                  ''
                )}
              </div>
            </Box>
            <Box fontSize="14px">{value.options.option2}</Box>
          </Flex>
          <Flex
            bgColor={'#F6F6F6'}
            color="#828282"
            width={isMobile? '90%' : '40%'}
            p={2}
            alignItems="center"
            gap={'4'}
            onClick={() => {
              handleAnswerChange(value.id, 'option3', number);
              // setAnswers({ ...answers, [value.id]: 'option3' });
            }}
          >
            <Box
              borderRadius="full"
              bg="white"
              borderColor="black"
              minH="20px"
              minW="20px"
              border="1px"
              position="relative"
            >
              <div
                style={{ position: 'absolute', left: '-3.5px', top: '-3px' }}
              >
                {answers[value.id] === 'option3' ? (
                  <HiCheckCircle fontSize="23px" color="#93C025" />
                ) : (
                  ''
                )}
              </div>
            </Box>
            <Box fontSize="14px">{value.options.option3}</Box>
          </Flex>
          <Flex
            bgColor={'#F6F6F6'}
            color="#828282"
            width={isMobile? '90%' : '40%'}
            p={2}
            alignItems="center"
            gap={'4'}
            onClick={() => {
              handleAnswerChange(value.id, 'option4', number);
              // setAnswers({ ...answers, [value.id]: 'option4' });
            }}
          >
            <Box
              borderRadius="full"
              bg="white"
              borderColor="black"
              minH="20px"
              minW="20px"
              border="1px"
              position="relative"
            >
              <div
                style={{ position: 'absolute', left: '-3.5px', top: '-3px' }}
              >
                {answers[value.id] === 'option4' ? (
                  <HiCheckCircle fontSize="23px" color="#93C025" />
                ) : (
                  ''
                )}
              </div>
            </Box>
            <Box fontSize="14px">{value.options.option4}</Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
